import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import {
	restoreDeletedChapter,
	updateChapterReorderConflictWithIncoming
} from '@editor2/services/conflictResolutionService';

export class ChapterDeletedModifiedConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, incoming } = conflict;
		state.initialCourse.chapters.entities[entityId] = incoming as any;
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, incoming } = conflict;
		restoreDeletedChapter(state, entityId);

		state.chapters.entities[entityId] = incoming as any;
		updateChapterReorderConflictWithIncoming(state, state.book.family_id);
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
